import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "./ui/button";

export default function LanguageToggle() {
  const { i18n } = useTranslation();
  const lang = (i18n.language || "en").slice(0, 2);
  const toggle = (next) => {
    i18n.changeLanguage(next);
    try { localStorage.setItem("sc_lang", next); } catch (e) {}
  };
  return (
    <div className="inline-flex items-center rounded-full border border-border bg-card p-0.5" data-testid="language-toggle">
      <button
        type="button"
        data-testid="language-toggle-en"
        onClick={() => toggle("en")}
        title="English"
        className={`px-2.5 py-1 text-xs font-medium rounded-full transition-colors ${lang === "en" ? "bg-[hsl(var(--primary))] text-white" : "text-muted-foreground hover:text-foreground"}`}
      >EN</button>
      <button
        type="button"
        data-testid="language-toggle-fr"
        onClick={() => toggle("fr")}
        title="Français"
        className={`px-2.5 py-1 text-xs font-medium rounded-full transition-colors ${lang === "fr" ? "bg-[hsl(var(--primary))] text-white" : "text-muted-foreground hover:text-foreground"}`}
      >FR</button>
    </div>
  );
}
